/*
 * @Author: 刑天
 * @Date: 2022-05-13 15:38:33
 * @LastEditTime: 2024-06-04 09:21:53
 * @Description: 战神
 */
import styled from 'styled-components';

export default styled.div`
  .form-component-wrap {
    input {
      text-align: right;
    }
    input::placeholder {
      text-align: right;
    }
  }
  .multiline-wrap .Mui-disabled .MuiOutlinedInput-notchedOutline {
    border: 1px dotted rgba(0, 0, 0, 0.42);
  }
  .upload-image-item:hover .montmorillonite-layer-wrap {
    display: block;
  }
  .upload-image-item:hover .montmorillonite-layer-in {
    display: flex;
    justify-content: center;
  }

  .montmorillonite-layer-wrap {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: #000;
    opacity: 0.5;
    display: none;
  }
  .montmorillonite-layer-in {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    color: #ffffff;
    display: none;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    /* flex-wrap: wrap; */
    /* padding: 0 35px; */
    box-sizing: border-box;
    background-color: transparent;
    gap: 0 16px;
    .icon-wrap {
      /* width: 32px;
      height: 32px;
      background-color: #ffffff; */
      border-radius: 50%;
      .icon-box {
        width: 100%;
        height: 100%;
        background-color: #000000;
        opacity: 0.7;
        border-radius: 50%;
        padding: 6px;
        box-sizing: border-box;
        .icon-style {
          width: 100%;
          height: 100%;
          color: #fff;
          cursor: pointer;
        }
      }
    }
  }
  .textField-area-wrap {
    height: auto;
    textarea {
      padding-top: 10px;
    }
  }
  .checkbox-radio-disabled-color .Mui-disabled {
    color: darkgray;
  }
  .error-size {
    .error-size-mb {
      color: red;
    }
  }
  .MuiFormHelperText-root.Mui-error {
    font-size: 12px;
  }
  .display-row {
    .MuiFormGroup-root {
      flex-direction: ${(props) => (props.row ? 'row' : 'column')};
    }
  }
  .checkbox-radio-disabled-color .Mui-disabled {
    color: darkgray;
  }
  .img-label-style {
    font-weight: 400;
    font-size: 12px;
    line-height: 17px;
    letter-spacing: 0.15px;
    color: #333333;
    margin-bottom: 8px;
  }
`;
